import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Container,
  useTheme,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import { motion } from 'framer-motion';

const MotionCard = motion(Card);

function Events({ events }) {
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      <Typography variant="h4" component="h2" gutterBottom sx={{ 
        fontWeight: 700,
        mb: 4,
        background: 'linear-gradient(45deg, #FF9800 30%, #FFB74D 90%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      }}>
        Market Events
      </Typography>
      <MotionCard
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        sx={{
          background: theme.palette.mode === 'dark' 
            ? 'rgba(255, 255, 255, 0.05)'
            : 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(10px)',
          borderRadius: 2,
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
          border: '1px solid rgba(255, 255, 255, 0.18)',
          maxHeight: '400px',
          overflow: 'auto'
        }}
      >
        <CardContent>
          <Box display="flex" alignItems="center" mb={3}>
            <NewspaperIcon sx={{ fontSize: 40, mr: 2, color: 'warning.main' }} />
            <Typography variant="h6">
              Latest Updates
            </Typography>
          </Box>
          
          {events.length === 0 ? (
            <Typography color="text.secondary" textAlign="center" py={4}>
              No events yet... Stay tuned for market updates! 📰
            </Typography>
          ) : (
            <List>
              {events.map((event, index) => (
                <React.Fragment key={index}>
                  <ListItem
                    component={motion.div}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <ListItemText 
                      primary={event}
                      secondary={new Date().toLocaleTimeString()}
                    />
                  </ListItem>
                  {index < events.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          )}
        </CardContent>
      </MotionCard>
    </Container>
  );
}

export default Events; 